import React, { useState, useEffect } from "react";
import { Chart } from "primereact/chart";
import { ViewportContext } from "../../../context/ViewportContext";

export default function Radar(props: any) {
  const [chartData, setChartData] = useState({});
  const [chartOptions, setChartOptions] = useState({});
  const { width } = React.useContext(ViewportContext);

  useEffect(() => {
    const documentStyle = getComputedStyle(document.documentElement);
    const textColor = "#b2b2b6";
    const textColorSecondary = "#b2b2b6";
    const data = {
      labels: props.labels,
      datasets: [
        {
          label: "Presupuesto Base",
          borderColor: documentStyle.getPropertyValue("--bluegray-400"),
          pointBackgroundColor:
            documentStyle.getPropertyValue("--bluegray-400"),
          pointBorderColor: documentStyle.getPropertyValue("--bluegray-400"),
          pointHoverBackgroundColor: textColor,
          pointHoverBorderColor:
            documentStyle.getPropertyValue("--bluegray-400"),
          data: props.data1,
        },
        {
          label:
            props.context === "order"
              ? "Presupuesto a tomar"
              : "Presupuesto Solicitado",
          borderColor:
            props.context === "order"
              ? documentStyle.getPropertyValue("--green-900")
              : documentStyle.getPropertyValue("--pink-500"),
          pointBackgroundColor:
            props.context === "order"
              ? documentStyle.getPropertyValue("--green-900")
              : documentStyle.getPropertyValue("--pink-500"),
          pointBorderColor:
            props.context === "order"
              ? documentStyle.getPropertyValue("--green-900")
              : documentStyle.getPropertyValue("--pink-500"),
          pointHoverBackgroundColor: textColor,
          pointHoverBorderColor:
            props.context === "order"
              ? documentStyle.getPropertyValue("--green-500")
              : documentStyle.getPropertyValue("--pink-500"),
          data: props.data2,
        },
      ],
    };
    const options = {
      plugins: {
        legend: {
          labels: {
            color: textColor,
          },
        },
      },
      scales: {
        r: {
          grid: {
            color: textColorSecondary,
          },
        },
      },
    };

    setChartData(data);
    setChartOptions(options);
  }, []);

  return (
    <div
      style={{
        display: width < 1081 ? "none" : "contents",
        width: width < 1081 ? "0%" : "100%",
      }}
    >
      <div
        style={{ width: "35%", marginRight: "4%" }}
        className="card flex justify-content-center"
      >
        {Object.keys(chartData).length > 0 &&
        Object.keys(chartOptions).length ? (
          <Chart
            type="radar"
            data={chartData}
            options={chartOptions}
            className="w-full md:w-30rem"
          />
        ) : null}
      </div>
    </div>
  );
}
